module.exports = __webpack_public_path__ + "static/media/doctor-landing-icon.cf15381a.svg";